import {Badge, Button, Dropdown, Empty, List, Spin, Tag, Typography} from 'antd';
import React from 'react';
import {useQueryWithStore} from 'react-admin';
import {BellOutlined, WarningOutlined} from '@ant-design/icons';
import useGetGeneralSettings from '../../providers/useGetGeneralSettings';
import { SecureMarkdownRenderer } from '../../ui/SecureMarkdownRenderer';

const NotificationInbox = () => {
    const { data, total, loaded } = useQueryWithStore({
        type: "getList",
        resource: "notifications",
        payload: {
            pagination: { page: 1, perPage: 20 },
            sort: { field: "id", order: "dsc" },
            filter: {}
        },
    });

    const generalSettings = useGetGeneralSettings();
    const bannerSettings = generalSettings.find((s: any) => s.name === 'GlobalBanner');
    const bannerEnabled = bannerSettings?.config?.ENABLED;
    const bannerMessage = bannerSettings?.config?.message;

    const badgeCount = (total || 0) + (bannerEnabled ? 1 : 0);

    const notificationContent = (
        <div style={{ width: 500, background: '#fff', borderRadius: 8, boxShadow: '0 3px 6px -4px rgba(0,0,0,.12), 0 6px 16px 0 rgba(0,0,0,.08)' }}>
            <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0' }}>
                <Typography.Text strong>Notifications</Typography.Text>
            </div>
            <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                {!loaded ? (
                    <div style={{ padding: 24, textAlign: 'center' }}><Spin /></div>
                ) : !data && !bannerEnabled ? (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No notifications" style={{ padding: 24 }} />
                ) : (
                    <List
                        dataSource={[
                            ...(bannerEnabled && bannerMessage ? [{ _isBanner: true, description: bannerMessage }] : []),
                            ...(data || []),
                        ]}
                        renderItem={(item: any) => (
                            item._isBanner ? (
                                <List.Item style={{ padding: '10px 16px', background: '#fffbe6' }}>
                                    <List.Item.Meta
                                        avatar={<WarningOutlined style={{ color: '#faad14', fontSize: 18, marginTop: 4 }} />}
                                        description={<SecureMarkdownRenderer content={item.description} />}
                                    />
                                </List.Item>
                            ) : (
                                <List.Item style={{ padding: '10px 16px' }}>
                                    <List.Item.Meta
                                        title={item.owner?.name}
                                        description={<SecureMarkdownRenderer content={item.description} />}
                                    />
                                </List.Item>
                            )
                        )}
                    />
                )}
            </div>
        </div>
    );

    return (
        <Dropdown dropdownRender={() => notificationContent} trigger={['click']} placement="bottomRight">
            <Badge count={badgeCount} size="small" offset={[-2, 2]}>
                <Button
                    type="text"
                    icon={<BellOutlined style={{ fontSize: 20 }} />}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 40, width: 40 }}
                />
            </Badge>
        </Dropdown>
    );
};

export default NotificationInbox;